import yup from '@/utils/customisedYup';
import React, { useState } from 'react';

import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';

import styles from './style.module.scss';

const Other = 'other';

export const phoneList = [
  { text: 'AUS (+61)', value: '+61' },
  { text: 'NZL (+64)', value: '+64' },
  { text: 'CAN (+01)', value: '+01' },
  { text: 'UK (+44)', value: '+44' },
  { text: 'USA (+01)', value: '+01' },
  { text: 'IRE (+353)', value: '+353' },
  { text: 'Other', value: Other },
];

interface IProps {
  onChange: (params) => void;
  area?: string;
  showArea?: boolean;
  phoneNumber?: string;
  error?: string;
  showRequired?: boolean;
}

const phoneNumberLengthHint = 'Min length is 6, and Max length is 20.';
const phoneNumberValidHint = `A valid phone number only contain '+' symbol and numeric values`;
const phoneNumberCountryCodeHint = `A valid phone number must contain country code e.g '+64'`;

export const phoneNumberSchema = yup
  .string()
  .trim()
  .min(6, phoneNumberLengthHint)
  .max(20, phoneNumberLengthHint)
  .matches(/^[\d+]*$/, phoneNumberValidHint)
  .matches(/^\+[\d]{1,20}$/, phoneNumberCountryCodeHint)
  .required();

export const PhoneNumber: React.FC<IProps> = ({
  error,
  area,
  phoneNumber,
  onChange,
  showArea = true,
  showRequired = false,
}) => {
  const [newPhone, setNewPhone] = useState({
    area: area || phoneList[0].value,
    phone: '',
  });

  const orgnizePhoneNumber = (area, phone) => {
    phone = phone.replace(/^0+/, '');
    return {
      area,
      phone,
      mixPhone: `${!showArea || area === Other ? '' : area}${phone}`,
    };
  };

  return (
    <>
      {showArea && (
        <FormControl className={styles.phoneArea}>
          <InputLabel id="area-code-select-label" />
          <Select
            labelId="area-code-select-label"
            id="area-code-select"
            inputProps={{ 'data-testid': 'area-code-select' }}
            value={newPhone.area}
            autoWidth
            onChange={e => {
              setNewPhone({
                ...newPhone,
                area: e.target.value + '',
              });
              onChange(orgnizePhoneNumber(e.target.value, newPhone.phone));
            }}
          >
            {phoneList.map(item => (
              <MenuItem key={item.text} value={item.value}>
                {item.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      <FormControl className={styles.phoneNumber}>
        <TextField
          required={showRequired}
          label={newPhone.area === Other ? 'Enter phone number with country code' : 'Phone number'}
          name="phoneNumber"
          id="phoneNumber"
          inputProps={{ 'data-testid': 'phone-number' }}
          className={styles.phoneNumber}
          fullWidth
          defaultValue={phoneNumber}
          error={!!error}
          onChange={e => {
            setNewPhone({
              ...newPhone,
              phone: e.target.value,
            });
            onChange(orgnizePhoneNumber(newPhone.area, e.target.value));
          }}
          helperText={error}
        />
      </FormControl>
    </>
  );
};
